import React, { FunctionComponent } from 'react';

import styles from './checkboxTooltip.module.scss';

export interface ICheckboxTooltipProps {
  tooltipText?: string;
}

export const CheckboxTooltipComponent: FunctionComponent<ICheckboxTooltipProps> = ({
  tooltipText
}) => {
  if (!tooltipText) return null;

  return (
    <div className={styles.tooltipWrapper}>
      <span className={styles.tooltipButton}>i</span>
      <div className={styles.tooltip}>{tooltipText}</div>
    </div>
  );
};

export const CheckboxTooltip = React.memo(CheckboxTooltipComponent);
